/**
 * Given a sentence, checks if any word in the sentence starts with the given prefix
 * @param sentence The sentence
 * @param prefix The prefix
 * @returns true if any word in the sentence starts with the prefix
 */
export function hasWordStartingWith(sentence: string, prefix: string): boolean {
  const lowerCasePrefix = prefix.toLowerCase();
  const words = sentence.toLowerCase().split(' ');

  // Check individual words
  if (words.some((word) => word.startsWith(lowerCasePrefix))) {
    return true;
  }

  //Check consecutive words
  const combinedPrefix = lowerCasePrefix.replace(/\s+/g, '');
  for (let i = 0; i < words.length - 1; i++) {
    let combined = words[i];
    for (let j = i + 1; j < words.length; j++) {
      combined += words[j]; // Combine without space
      if (combined.startsWith(combinedPrefix)) {
        return true;
      }
      // If combined is already longer than prefix and doesn't match, no point continuing
      if (combined.length > combinedPrefix.length) {
        break;
      }
    }
  }

  return false;
}

export function isJSON(str: string) {
  if (!str) {
    return false;
  }
  try {
    JSON.parse(str);
    return true;
  } catch (error) {
    return false;
  }
}

export function trimObjectValues<T extends Record<string, any>>(
  obj: T,
  keys: Array<keyof T>,
): T {
  keys.forEach((key) => {
    const value = obj[key];
    if (typeof value === 'string') {
      obj[key] = value.trim();
    }
  });

  return obj;
}
